"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GleamCompetitionActionsResponseToJSON = exports.GleamCompetitionActionsResponseFromJSONTyped = exports.GleamCompetitionActionsResponseFromJSON = void 0;
var _1 = require("./");
function GleamCompetitionActionsResponseFromJSON(json) {
    return GleamCompetitionActionsResponseFromJSONTyped(json, false);
}
exports.GleamCompetitionActionsResponseFromJSON = GleamCompetitionActionsResponseFromJSON;
function GleamCompetitionActionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'actions': (json['actions'].map(_1.GleamCompetitionActionFromJSON)),
    };
}
exports.GleamCompetitionActionsResponseFromJSONTyped = GleamCompetitionActionsResponseFromJSONTyped;
function GleamCompetitionActionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'actions': (value.actions.map(_1.GleamCompetitionActionToJSON)),
    };
}
exports.GleamCompetitionActionsResponseToJSON = GleamCompetitionActionsResponseToJSON;
